

<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Aarambh Induction </h1>
                </div>
            </div>
        </div>			
    </div>
</section>      
    <ul class="breadcrumb">
        <li><a href="#">Event</a></li>
        <li><i class="fa fa-angle-double-right"></i></li>
        <li>Aarambh Induction </li>
    </ul>

<section class="section-lg chair-msg">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="text-justify" >
                    <p>G H Raisoni College of Commerce, Science & Technology conducted a five day induction program ‘AARAMBH-2022’ for the new batch of BBA & BCCA, BCA & B Com (Hon.), consisting of several befitting sessions for the new joiners.c</p>
                    <p>The first day of the event was started with a welcome note of the Deans of different verticals along with the Principal Dr Jasvinder Kaur. The students, then, were made aware with the activities take place throughout the year with the help of video stills and power point presentation. The day ended primarily by interesting management games By Manpreet Kaur and later a power packed Movie Review session by Dr. Rozina Rana (Psychologist and Life Coach).The second day of the induction program got illuminated with the sessions like CNA quiz By CA Dr Manish Shah and Zumba by Choreographer Chetan Dusmukhe and his team. </p>
                    <p>The third day students enjoyed the musical Housie conducted by Riya Shrivastava and Anuja Chaterjee followed by Personality Grooming Session by Kanak Bhowmik (Personality Groomer and Fitness Coach) which continued till next day and ended with the most exciting show Kaun Banega Champion by Mr. Vishal Dhabalia.</p>
                    <p>On the final day students organized FETE, where in they practically implemented their management skills which they learnt from the entire induction program. </p>
                    <p>All events were very innovative and productive as these were designed to make students comfortable with the college environment in form of performing lots of fun filled activities every day in form of assignments.</p>
                    <p>Event was a grand success with more than 200 students’ participation. The event was anchored by prolific senior students under the guidance of Mrs Madhuri Barua,(Dean, Student Activities) Dr. Jyoti Pillay (Dean, Training & Placement) and CA Dr. Manish Shah(Coordinator- III cell).</p>
                    <p>Mrs Kalyani Dubey and Mrs Shubhangi Mohod helped in successful conduct of this magnificent event.</p>
                    <p>The key inspiration behind the program was Dr. Aarti Deshpande, Director, Raisoni Business School who gave all motivation and insight to organize the event. </p>
                </div> 
            </div>
        </div>
        <div class="row mb-20">
            <div class="col-md-3 col-6">
              <div class="gallery-item" data-aos="zoom-in-down">
                <a href="assets/images/gallery/aarambh-1.webp" data-lightbox="example-set" data-title="Ghrcacsn GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/aarambh-1.webp" alt="Ghrcacsn | events" title="Ghrcacsn | events">
                    <div class="gallery-overlay"></div>
                </a>
              </div>
            </div>
            <div class="col-md-3 col-6">
              <div class="gallery-item" data-aos="zoom-in-down">
                <a href="assets/images/gallery/aarambh-2.webp" data-lightbox="example-set" data-title="Ghrcacsn GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/aarambh-2.webp" alt="Ghrcacsn | events" title="Ghrcacsn | events">
                    <div class="gallery-overlay"></div>
                </a>
              </div>
            </div>
            <div class="col-md-3 col-6">
              <div class="gallery-item" data-aos="zoom-in-down">
                <a href="assets/images/gallery/aarambh-3.webp" data-lightbox="example-set" data-title="Ghrcacsn GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/aarambh-3.webp" alt="Ghrcacsn | events" title="Ghrcacsn | events">
                    <div class="gallery-overlay"></div>
                </a>
              </div>
            </div>
           
        </div>
    </div>
</section>

